import CloseIcon from '@mui/icons-material/Close';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Alert, Button, IconButton, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import titleCase from 'common/utils/titleCase';

const PendingVialBanner = ({ vial, hasCurrent, onAttach, onDismiss }) => {
  if (!vial) return null;
  return (
    <Alert
      severity='warning'
      icon={<WarningAmberIcon />}
      action={
        <Stack direction='row' spacing={1} alignItems='center'>
          {hasCurrent && (
            <Button color='inherit' size='small' onClick={onAttach}>
              Attach to current Rx
            </Button>
          )}
          <IconButton size='small' onClick={onDismiss} aria-label='Dismiss'>
            <CloseIcon fontSize='small' />
          </IconButton>
        </Stack>
      }
    >
      <Typography variant='body2'>
        A drug vial was scanned with no active Rx session
        {vial.fields.drugName ? ` (${titleCase(vial.fields.drugName)})` : ''}. Scan an Rx bottle
        first, or dismiss this vial.
      </Typography>
    </Alert>
  );
};

PendingVialBanner.propTypes = {
  vial: PropTypes.shape({ fields: PropTypes.shape({ drugName: PropTypes.string }) }),
  hasCurrent: PropTypes.bool.isRequired,
  onAttach: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

PendingVialBanner.defaultProps = {
  vial: null,
};

export default PendingVialBanner;
